import { HttpResponse } from "@/fetchInterceptor/AxiosMethod";
import { OutlookAppointmentRecurrenceDto, OutlookRecipientDto } from "@/index";
import { DateTimePeriodDto } from "@/out-look/dto/DateTimePeriodDto";
import { IConvertDateTimeToUTCReq, IConvertDateTimeToUTCResp, IFetchRequest, IFetchResourceRequest, Organizer } from "@/services";
import { AttendeeInfo } from "@/services/attendee-service/entity/AttendeeEntity";
import { OutLookInfo } from "@/services/organization-service/entity/OutLookEntity";

export interface IResourceFinderProps {
  getOrgInfo?: (outlookUid: string, isReOpen?: boolean) => void;
  getSettingOrgInfo?:(payload: IFetchRequest) => void;
  getCategorization?: (orgId: string) => void;
  updateOutlookInfo?: (outlookInfo: OutLookInfo) => void;
  updateOrganizer?: (org: Organizer) => void;
  updateTimeOfOutlook?: (time: DateTimePeriodDto) => void;
  updateResourceSelectedFromOutlook?: (resources: OutlookRecipientDto[]) => void;
  updateRecurringOfOutlook?: (recurringInfo: OutlookAppointmentRecurrenceDto) => void;
  setTheme?: (themeId: string) => void;
  deleteSelectWhenFromOutlook?: (resourceEmails: string[]) => void;
  getResourcesDataForSelected?: (request: IFetchResourceRequest, outlookRecipientDto : OutlookRecipientDto[], isRecurring?: boolean) => Promise<void>;
  getAllResourcesDataInSelected?: (request: IFetchResourceRequest, isRecurring?: boolean) => Promise<void>;
  addInitAttendee?: (payload: AttendeeInfo) => void;
  onConvertDateTimeToUTC?: (req: IConvertDateTimeToUTCReq) => Promise<HttpResponse<IConvertDateTimeToUTCResp>>;
  onResetNotification?: () => void;
}

export enum ResourceAllowOrderForm {
  Allow = 0,
  LightResource = 1,
  ChildVR = 2,
  DifferentSOF = 3,
  Tentative = 4,
  IsRecurring =5,
  Denied = 6,
  Workspace = 7
}